import PropTypes from "prop-types";
import React from "react";

import classnames from "classnames";
import styles from "./Button.css";


const Button = ({ className, label, type = "main", children, processing, ...otherProps }, { getMediaUri }) => {
  const buttonClasses = classnames(styles.button, styles[type], className, {
    [styles.processing]: processing
  });
  const text = label || children;
  const spinner = processing ?
      <img className={styles.spinner}
          src={getMediaUri("/images/static/loader-orange.gif")} /> :
      null;

  return (
      <button className={buttonClasses} {...otherProps}>{spinner} {text}</button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.element,
  label: PropTypes.string,
  type: PropTypes.string,
  processing: PropTypes.bool
};

Button.contextTypes = {
  getMediaUri: PropTypes.func
};

export default Button;
